<template>
  <div id="content" class="app-content">
    <!-- page header -->
    <b-row>
      <b-col>
        <h1 class="page-header">Invoices <small>all listings.</small></h1>
      </b-col>
    </b-row>

    <mega-table ref="table" :api="invoices" :fields="fields" :pagination-route="{ name: 'invoices' }" show-details>
      <template v-slot:cell(pdf)="{ item }">
        <a href="#" @click.prevent="downloadInvoice(item.id)"> <i class="fa fa-download" /> Download </a>
      </template>
      <template v-slot:cell(paid_at)="{ value, item }">
        <span v-if="value">{{ value }}</span>
        <b-button v-else size="sm" variant="default" @click="markAsPaid(item)">Mark as Paid</b-button>
      </template>
      <template v-slot:row-details="{ item, loaded }">
        <invoice-details :invoice="item" @loaded="loaded" />
      </template>
    </mega-table>
  </div>
</template>

<script>
import { invoices } from '@youwish1/api-package'
import MegaTable from '../../components/MegaTable'
import { formatMoney, formatDate } from '../page-helpers'
import InvoiceDetails from './InvoiceDetails.vue'

export default {
  name: 'InvoicePage',
  components: { MegaTable, InvoiceDetails },
  computed: {
    invoices() {
      return invoices
    },
    fields() {
      return [
        { key: 'id', label: 'ID', sortable: false },
        {
          key: 'supplier',
          label: 'Legal name',
          sortable: false,
          formatter: value => value.invoice_legal_name,
        },
        { key: 'expires_at', formatter: value => formatDate(value) },
        { key: 'transaction_sum', formatter: value => formatMoney(value) },
        { key: 'sum', formatter: value => formatMoney(value) },
        { key: 'paid_at', formatter: value => (value ? formatDate(value) : null) },
        { key: 'pdf', label: 'Download' },
      ]
    },
  },
  methods: {
    async markAsPaid(item) {
      await this.invoices.markAsPaid(item.id)
      this.$bvToast.toast(`Invoice #${item.id} was successfully marked as paid.`, {
        title: 'Invoice paid',
        variant: 'primary',
      })
      this.$refs.table.refresh()
    },
    async downloadInvoice(id) {
      const res = await invoices.download(id)
      window.open(res.url, '_blank').focus()
    },
  },
}
</script>
